import html2canvas from 'html2canvas';
import { Platform } from 'react-native';

export class ScreenshotCaptureError extends Error {
  constructor(message: string, public originalError?: any) {
    super(message);
    this.name = 'ScreenshotCaptureError';
  }
}

export const captureScreenshot = async (): Promise<File> => {
  // Only works on web platform
  if (Platform.OS !== 'web') {
    throw new ScreenshotCaptureError('Screenshot capture only available on web platform');
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new ScreenshotCaptureError('Window or document not available');
  }

  try {
    // Capture the current viewport
    const canvas = await html2canvas(document.body, {
      height: window.innerHeight,
      width: window.innerWidth,
      scrollX: 0,
      scrollY: 0,
      useCORS: true,
      allowTaint: false,
      backgroundColor: '#ffffff',
      scale: 1,
    });

    // Convert canvas to blob
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to convert canvas to blob'));
          }
        },
        'image/png',
        0.9
      );
    });

    // Create File object with timestamp
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const filename = `feedback-screenshot-${timestamp}.png`;
    
    return new File([blob], filename, {
      type: 'image/png',
      lastModified: Date.now(),
    });

  } catch (error: any) {
    console.error('Screenshot capture failed:', error);
    throw new ScreenshotCaptureError(
      'Failed to capture screenshot. This might be due to browser permissions or page content.',
      error
    );
  }
};

export const isScreenshotSupported = (): boolean => {
  return Platform.OS === 'web' && 
         typeof window !== 'undefined' && 
         typeof document !== 'undefined' &&
         'toBlob' in HTMLCanvasElement.prototype;
}; 